<template>
    <div class="address-book">
        <el-dialog width="75%" :visible.sync="dialogFormVisible" :close-on-click-modal="false"
                   :before-close="handleClose">
            <div slot="title">{{group.id?'编辑:':'新增'}}
                <b class="text-info ml-2" v-if="group.id"> {{ group.name }} </b>
            </div>
            <el-row type="flex" justify="space-around" class="group-name-row">
                <div class="label"><span class="text-danger">*</span>名称:</div>
                <el-input size='small' placeholder="请输入名称" v-model="group.name"></el-input>
                <div class="label">备注:</div>
                <el-input size='small' placeholder="请输入备注" v-model="group.memo"></el-input>
            </el-row>
            <div class="line"></div>
            <el-row type="flex" justify="space-around">
                <el-col :span="12" class="left-panel">
                    <div class="panel-header">
                        <el-button type="default" plain size="small" class="float-right" @click="clearAddressBook">
                            <i class="fa fa-times-circle"></i> 清空
                        </el-button>
                        选中的参会者
                    </div>
                    <div class="panel-body">
                        <div v-for="item in address_book" class="address-item" :key="item.email" @dblclick="putEmailBack(item)">
                            {{item.name}}&lt;{{item.email}}&gt;
                            <div class="icon-button" @click="removeOneEmail(item)">
                                <i class="fa fa-times-circle"></i></div>
                        </div>
                    </div>
                    <div class="panel-footer">
                        <el-input type="textarea" v-model="import_text" style="height: 66px;"
                                  placeholder="输入email,可以批量，用','分割. 格式为 姓名 email,"></el-input>
                    </div>
                </el-col>
                <el-col :span="12" class="right-panel">
                    <div class="panel-header">
                        <el-button type="default" plain size="small" class="float-right" @click="addToAddress">
                            <i class="fa fa-arrow-circle-left"></i> 添加
                        </el-button>
                        <el-input size="mini" type="text" placeholder="搜索备用参会者" v-model="filter"
                                  clearable @clear="getYellowBook()"
                                  style="width: calc(100% - 80px)" @keyup.native="debounced()"></el-input>
                    </div>
                    <div class="panel-body">
                        <el-tabs tab-position="bottom" type="border-card"
                                 style="height: 312px;" @tab-click="handleTabClick">
                            <el-tab-pane v-for="tab in reference_tabs"
                                         :value="tab_index" :key="tab"
                                         :label="tab" style="height: 100%">
                                <div v-if="tab === '联系人'" style="height: 100%;overflow: auto;">
                                    <div v-for="item in contacts_filter" class="reference-item" :key="item.email"
                                         @dblclick="addOneEmail(item)" style="border-bottom: 1px solid #eee;">
                                        <div class="d-flex"
                                             style="font-size:13px;padding: 2px 0;margin-bottom: 2px;">
                                            <div class="d-flex justify-content-start align-items-center"
                                                 style="min-width: 5em;margin-right: 5px;color: #607d8b">
                                                <b>{{item.name}}</b>
                                            </div>
                                            <div style="line-height: normal; font-size: 13px;">
                                                {{item.department}}<br/>
                                                {{item.email}}
                                            </div>
                                        </div>
                                        <div class="icon-button">
                                            <el-checkbox v-model="item.select"></el-checkbox>
                                        </div>
                                    </div>
                                </div>
                                <!-- 通讯组  -->
                                <div v-if="tab === '通讯组'" style="height: 100%;overflow: auto;">
                                    <div v-for="groupItem in group_filter" class="reference-item-head text-info"
                                         :key="groupItem.id"
                                         @dblclick="addGroupEmail(groupItem)">

                                        <div class="title-wrap">
                                            <div class="title-icon" @click.prevent="expendGroup(groupItem)">
                                                <i class="el-icon-arrow-right"
                                                   :class="groupItem.collapsed?'rotate-90':''"></i>
                                            </div>
                                            <div class="title">
                                                {{groupItem.name}}
                                                <div class="icon-button">
                                                    <el-checkbox v-model="groupItem.select"></el-checkbox>
                                                </div>
                                            </div>
                                        </div>
                                        <el-collapse-transition>
                                            <div class="group-emails" v-if="groupItem.collapsed">
                                                <div v-for="item in groupItem.email_array" class="reference-item"
                                                     :key="item.email+item.name"
                                                     @dblclick="addOneEmail(item)"
                                                     style="border-bottom: 1px solid #eee;">
                                                    <div class="d-flex"
                                                         style="line-height:normal;font-size:13px;padding: 2px 0;margin-bottom: 2px;">
                                                        <div style="min-width: 8em;margin-right: 5px;color: #607d8b">
                                                            {{item.user_id | noEmail}}<br/>
                                                            <b>{{item.name}}</b>
                                                        </div>
                                                        <div style="line-height: normal; font-size: 13px;margin-left: 10px;">
                                                            {{item.department}} <br/>
                                                            {{item.email}}
                                                        </div>
                                                    </div>
                                                    <div class="icon-button">
                                                        <el-checkbox v-model="item.select"></el-checkbox>
                                                    </div>
                                                </div>
                                            </div>
                                        </el-collapse-transition>
                                    </div>
                                </div>
                                <!-- 黄页 -->
                                <div v-if="tab === '黄页'" style="height: 100%;overflow: auto;"
                                     v-infinite-scroll="loadYellowMore">
                                    <div v-for="item in yellow_book" class="reference-item" :key="item.id"
                                         @dblclick="addOneEmail(item)" style="border-bottom: 1px solid #eee;">
                                        <div class="d-flex"
                                             style="line-height:normal;font-size:13px;padding: 2px 0;margin-bottom: 2px;">
                                            <div style="min-width: 8em;margin-right: 5px;color: #607d8b">
                                                {{item.user_id | noEmail}}<br/>
                                                <b>{{item.name}}</b>
                                            </div>
                                            <div style="line-height: normal; font-size: 13px;margin-left: 10px;">
                                                {{item.department}} <br/>
                                                {{item.email}}
                                            </div>
                                        </div>
                                        <div class="icon-button">
                                            <el-checkbox v-model="item.select"></el-checkbox>
                                        </div>
                                    </div>
                                </div>
                            </el-tab-pane>
                        </el-tabs>
                    </div>
                </el-col>
            </el-row>
            <div slot="footer" class="dialog-footer">
                <el-button class="pull-left" type="primary" plain @click="importEmails">添加输入人员</el-button>
                <el-button @click.native="$emit('cancel')">取 消</el-button>
                <el-button type="primary" @click.native="editSubmit">确 定</el-button>
            </div>
        </el-dialog>

    </div>
</template>

<script>

    import ElCollapseTransition from "element-ui/lib/transitions/collapse-transition";

    export default {
        name: "group-edit",
        components: {ElCollapseTransition},
        data() {
            return {
                dialogFormVisible: this.edit_mode,
                address_book: [],
                yellow_book: [],
                reference_book: [],
                contact_book: [],
                group_book: [],
                import_text: '',
                filter: '',
                group: {},
                reference_tabs: ['联系人', '通讯组'],
                tab_index: '联系人',
                debounced: null,
            }
        },
        props: {
            edit_mode: {
                type: Boolean,
                default() {
                    return false;
                }
            },
            single: {
                type: Object,
                default() {
                    return {};
                }
            },
            model: {
                type: String,
                default() {
                    return '';
                }
            }
        },
        filters: {
            noEmail(value) {
                if (typeof value === 'string') {
                    return value.split('@')[0];
                }
            }

        },
        computed: {
            reference_filter() {
                let vm = this;
                return this.reference_book.filter(function (item) {
                    return (item.email.indexOf(vm.filter) !== -1);
                })
            },
            contacts_filter() {
                let vm = this;
                return this.contact_book.filter(function (item) {
                    return (item.department && item.department.indexOf(vm.filter) !== -1) || (item.name && item.name.indexOf(vm.filter) !== -1);
                })
            },
            group_filter() {
                let vm = this;
                return this.group_book.filter(function (item) {
                    return (item.name.indexOf(vm.filter) !== -1);
                });
            }
        },
        watch: {
            edit_mode: {
                handler(newVal) {
                    this.dialogFormVisible = newVal;
                }
            },
            single: {
                handler(newVal) {
                    this.getGroupBook();
                    this.group = Object.assign({},newVal);
                    let address_book = null;
                    try {
                        address_book = JSON.parse(newVal.emails);
                    } catch (e) {
                        address_book = null;
                    }
                    if (Array.isArray(address_book)) {
                        this.address_book = address_book;
                    } else {
                        this.address_book = [];
                    }
                }
            }
        },
        methods: {
            handleTabClick(item) {
                this.tab_index = item.label;
            },
            handleClose(done) {
                done();
                this.$emit('cancel');
            },
            editSubmit() {
                const vm = this;
                if (this.group.name) {
                    this.group.emails = JSON.stringify(this.address_book);
                    this.$api(this.model + '.Edit', this.group, true).then(() => {
                            this.$notice.success('记录更新成功!');
                            vm.$emit('success');
                        }
                    );
                } else {
                    this.$notice.error('请填写名称!');
                }
            },
            addToAddress() {
                const vm = this;
                if (this.tab_index === '联系人') {
                    this.contact_book.forEach(item => {
                        if (item.select) {
                            item.select = false;
                            vm.addOneEmail(item);
                        }
                    });
                } else if (this.tab_index === '黄页') {
                    this.yellow_book.forEach(item => {
                        if (item.select) {
                            item.select = false;
                            vm.addOneEmail(item);
                        }
                    });
                } else if (this.tab_index === '通讯组') {
                    this.group_book.forEach(item => {
                        if (item.select) {
                            item.select = false;
                            if (item.email_array) {
                                item.email_array.forEach((item) => {
                                    vm.addOneEmail(item);
                                });
                            }
                        } else {
                            if (item.email_array) {
                                item.email_array.forEach((item) => {
                                    if (item.select)
                                        vm.addOneEmail(item);
                                });
                            }
                        }
                    });
                }
            },
            clearAddressBook() {
                this.address_book.splice(0, this.address_book.length);
            },
            removeOneEmail(item) {
                const index = this.address_book.indexOf(item);
                if (index >= 0) this.address_book.splice(index, 1);
            },
            addOneEmail(item) {
                const vm = this;
                item.select = false;
                let found = false;
                vm.address_book.forEach(rec => {
                    if (rec.email === item.email) {
                        found = true;
                    }
                });
                if (!found) vm.address_book.push(item);
            },
            importEmails() {
                const raw = this.import_text.replace(/，/g, ',').split(',');
                const vm = this;
                raw.forEach(function (item) {
                    const regex = /[a-zA-Z0-9_-|.-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+/ig;
                    if (item.match(regex)) {
                        const email = item.match(regex)[0];
                        const start = item.indexOf(email);
                        let name = item.substr(0, start).trim();
                        if (!name) {
                            name = email.split('@')[0];
                        }
                        let found = false;
                        vm.address_book.forEach(rec => {
                            if (rec.email === email) {
                                rec.name = name;
                                found = true;
                            }
                        });
                        if (!found) vm.address_book.push({name: name, email: email});
                    }
                });

                this.import_text = '';
            },
            getContactBook() {
                this.$api('Query.Contacts', {}, 1).then(res => {
                    this.contact_book = res.data.data;
                });
            },
            getGroupBook(){
                this.$api('Query.Groups', {}, 1).then(res => {
                    this.group_book = res.data.data;
                });
            },
            getYellowBook(page) {
                const vm = this;
                if (!page) page = 1;
                this.$api('Query.Yellow', {query: this.filter, page: page}, 1).then(res => {

                    vm.yellow_next = res.data.data.current_page < res.data.data.last_page ? (1 + res.data.data.current_page) : 0;
                    if (page === 1) {
                        vm.yellow_book = [];
                        res.data.data.data.forEach(function (item) {
                            vm.yellow_book.push(Object.assign({}, {select: false}, item));
                        })
                    } else {
                        res.data.data.data.forEach(function (item) {
                            vm.yellow_book.push(item);
                        });
                    }
                });
            },
            loadYellowMore() {
                if (this.yellow_next !== 0) this.getYellowBook(this.yellow_next);
            },
            expendGroup(item) {
                this.$set(item, 'collapsed', !item.collapsed);
            },
            addGroupEmail(item) {
                const vm = this;
                item.select = false;
                if (item.email_array) {
                    item.email_array.forEach((item) => {
                        vm.addOneEmail(item);
                    });
                }
            },
            putEmailBack(item) {
                this.import_text = item.name + ' ' + item.email;
            }
        },
        mounted() {
            let vm = this;
            this.debounced = this.$debounce(1000, function () {
                vm.getYellowBook();
            });
            this.getContactBook();
            if(this.preset && this.preset.app && this.preset.app.yellow) {
                this.reference_tabs.push('黄页');
                this.getYellowBook();
            }
        }
    }
</script>

<style lang="scss">

    .address-book {
        .group-name-row {
            height: 32px;
            margin: 5px 0;

            .label {
                width: 120px;
                line-height: 32px;
                text-align: center;
            }
        }

        .line {
            height: 0;
            border-bottom: 2px solid #ecf5ff;
            margin-bottom: 5px;
        }

        .left-panel {
            padding-right: 5px;
            margin-right: 5px;
            border-right: 1px solid #eee;

            .panel-body {
                height: 246px;
            }
        }

        .panel-header {
            height: 40px;
            background-color: #EEE;
            line-height: 32px;
            padding: 4px 10px;

        }

        .panel-body {
            overflow: auto;
        }

        .right-panel {
            background-color: transparent;

            .panel-body {
                height: calc(100% - 40px);
                background-color: #F9F8F9;

                .el-tabs__content {
                    height: calc(100% - 39px);
                    padding: 0 15px;
                }

                .el-tabs--bottom .el-tabs__header.is-bottom {
                    margin-top: 0 !important;
                }
            }
        }

        .el-dialog__body {
            padding: 5px 20px;
        }

        .address-item {
            line-height: 28px;
            color: #333;
            padding: 2px 25px 2px 10px;
            position: relative;
            transition: all 0.2s ease-in;
            border-radius: 0;
            cursor: pointer;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            font-size: 13px;
            border-bottom: 1px solid #eee;

            .icon-button {
                position: absolute;
                right: 7px;
                top: 1px;
                padding: 0 2px;
                font-size: 15px;
                cursor: pointer;
                transition: all 0.2s ease-in;
                opacity: 0.1;

                &:hover {
                    color: #0288d1;
                    transform: scale(1.5);
                }
            }

            &:hover {
                background-color: #e0f7fa;

                .icon-button {
                    opacity: 1;
                }
            }
        }

        .reference-item-head {
            padding: 5px 0;
            position: relative;

            .title-wrap {
                border-bottom: 2px solid #E0E0E0;

                .title-icon {
                    float: left;
                    font-weight: bold;
                    display: block;
                    color: #607d8b;
                    line-height: 28px;
                    height: 28px;
                    padding: 2px;
                    width: 18px;
                    cursor: pointer;
                    transition: all 0.2s ease-in;

                    &:hover {
                        background-color: #e0f7fa;
                    }

                    i {
                        transition: all 0.2s ease-in;
                    }

                    .rotate-90 {
                        transform: rotate(90deg);
                    }
                }


                .title {
                    line-height: 28px;
                    color: #607d8b !important;

                    .icon-button {
                        top: 1px !important;
                    }

                    &:hover {
                        background-color: #e0f7fa;

                        .icon-button {
                            opacity: 1;
                        }
                    }
                }
            }

            .group-emails {
                padding: 10px 0 10px 15px;
            }
        }

        .reference-item, .reference-item-head .title {
            line-height: 28px;
            color: #333;
            padding: 2px 25px 2px 10px;
            position: relative;
            transition: all 0.2s ease-in;
            border-radius: 0;
            cursor: pointer;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;

            .icon-button {
                position: absolute;
                right: 7px;
                top: 5px;
                padding: 0 2px;
                font-size: 15px;
                cursor: pointer;
                transition: all 0.2s ease-in;
                opacity: 1;

                &:hover {
                    color: #0288d1;
                    transform: scale(1.5);
                }
            }

            &:hover {
                background-color: #e0f7fa;

                .icon-button {
                    opacity: 1;
                }
            }
        }
    }
</style>
